Object.defineProperty(exports, "__esModule", { value: true });
exports.SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];
//# sourceMappingURL=enums.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/utils/dist/enums.js
// module id = 867
// module chunks = 1